<template>
  <modal
    :title="'Pin Appointment'"
    class-name="small-modal"
    :saving="saving"
    :cancel-button="true"
    @submit="handleSubmit"
    @hide-modal="handleHideModal"
  >
    <div>
      <p class="mb-4">
        Are you sure you want to pin this appointment to
        {{ technicianName }}?
      </p>
      <span class="label"> Reason (Optional) </span>
      <TextArea v-model="pinnedReason"></TextArea>
    </div>
  </modal>
</template>

<script>
import { mapActions } from "vuex";

import Modal from "@/components/Modal.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
export default {
  components: {
    Modal,
    TextArea
  },
  props: {
    appointmentId: {
      type: String,
      default: null
    },
    technicianId: {
      type: Number,
      default: null
    },
    technicianName: {
      type: String,
      default: null
    },
    pendingTimePayload: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      pinnedReason: "",
      saving: false
    };
  },
  methods: {
    ...mapActions(["updateAppointmentEvent"]),
    handleHideModal() {
      this.$emit("hide-modal");
    },
    handleSubmit() {
      this.saving = true;
      const payload = {
        appointmentId: this.appointmentId,
        technician_profile_id: this.technicianId,
        pinned_reason: this.pinnedReason,
        ...this.pendingTimePayload
      };
      this.updateAppointmentEvent(payload)
        .then(() => {
          window.notify.success("Appointment updated");
        })
        .finally(() => {
          this.saving = false;
          this.$emit("hide-modal");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
